import React, { useMemo } from "react"
import parseVCard from "../utils/parseVCard"
import { Avatar, Typography } from "@material-ui/core"
import { Person } from "@material-ui/icons"

/**
 * @typedef {Object} ParsedVCard
 * @property {string} name
 * @property {string} phone
 * @property {string} [photo]
 */

/**
 * @typedef {Object} QuotedContactProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 */

const QuotedContact = React.memo(
  /**
   * @param {QuotedContactProps} props
   */
  ({ message, classes }) => {
    /** @type {ParsedVCard} */
    const contact = useMemo(() => parseVCard(message.body), [message.body])

    const renderAvatar = () => {
      if (contact.photo) {
        return (
          <img
            src={`data:image/jpeg;base64,${contact.photo}`}
            alt="Contact"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        )
      }

      const firstChar = contact.name.charAt(0)
      const isPhone = firstChar === "+" || !isNaN(firstChar)

      return <Avatar className={classes.avatar}>{isPhone ? <Person /> : firstChar}</Avatar>
    }

    return (
      <div className={`${message.fromMe ? classes.messageRight : classes.messageLeft}`} style={{ width: 300 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {renderAvatar()}
          <Typography variant="subtitle1" noWrap={contact.name.length > 50}>
            {contact.name}
          </Typography>
        </div>

        <Typography style={{ display: "flex", alignItems: "center", justifySelf: "center" }} variant="body2">
          {contact.phone}
        </Typography>
      </div>
    )
  },
)

QuotedContact.displayName = "QuotedContact"

export default QuotedContact
